import React, { useContext } from "react";
import {
  InlineStack,
  BlockStack,
  LegacyCard as Card,
  Badge,
  Link,
  Thumbnail,
  Text,
  Button,
  Icon,
} from "@shopify/polaris";
import { NoteIcon } from "@shopify/polaris-icons";
import _ from "lodash";

import { PrivateContext } from "lib/context";

// import helpers
import { baseHelper } from "lib/helpers";
import constant from "lib/constant/constant";

// import propTypes
import { fulfilledLineItemsProps } from "app/orderLake/modules/operator/features/view/propsType";
import { StyledCard } from "app/orders/modules/operator/features/view/genericStyled";
import { useNavigate, useParams } from "react-router-dom";

const FulfilledLineItems = (props) => {
  const { lineData, fulfillmentType, setFulfillmentType } = props;
  const { cms, currentUser } = useContext(PrivateContext);
  const navigate = useNavigate();
  const { id } = useParams();
  const { moneyFormat } = currentUser;
  const vendorsSum = [];
  const countItems =
    lineData &&
    lineData.filter(
      (lineItem) =>
        ([constant.PARTIAL_SHIPPED, constant.PARTIAL_SHIP_SPACE].includes(
          lineItem.storeStatus && lineItem.storeStatus.toLowerCase()
        ) &&
          lineItem.trackingCompany &&
          lineItem.trackingNumber) ||
        [constant.COMPLETE, constant.SHIPPED].includes(lineItem.storeStatus && lineItem.storeStatus.toLowerCase())
    ).length;

  const isBigCommerceUser = baseHelper.isBigCommerceUser(currentUser);

  const subTotalAmount = lineData
    .filter(
      (lineItem) =>
        ([constant.PARTIAL_SHIPPED, constant.PARTIAL_SHIP_SPACE].includes(
          lineItem.storeStatus && lineItem.storeStatus.toLowerCase()
        ) &&
          lineItem.trackingCompany &&
          lineItem.trackingNumber) ||
        [constant.COMPLETE, constant.SHIPPED].includes(lineItem.storeStatus && lineItem.storeStatus.toLowerCase())
    )
    .map((item) => {
      let total = 0;
      const totalPrice = parseFloat(item.quantity) * parseFloat(isBigCommerceUser ? item.basePrice : item.price);
      if (item && item.providerId && !vendorsSum.includes[item.providerId]) {
        vendorsSum.push(item.providerId);
      }
      total = parseFloat(total) + parseFloat(totalPrice);
      return total;
    });
  const vendorSet = new Set(vendorsSum);
  const setSize = vendorSet.size;
  const addVendorTxt =
    setSize === constant.value.ONE ? `${setSize} ${cms("label.vendor")}` : `${setSize} ${cms("label.vendors")}`;

  const totalAmount = subTotalAmount.reduce((total, item) => {
    return total + item;
  }, 0);

  const lineItems = lineData.map((lineItem, idx) => {
    if (
      !lineItem ||
      ([constant.PARTIAL_SHIPPED, constant.PARTIAL_SHIP_SPACE].includes(
        lineItem.storeStatus && lineItem.storeStatus.toLowerCase()
      ) &&
        !(lineItem.trackingCompany && lineItem.trackingNumber))
    ) {
      return null;
    }
    const lineImage = lineItem.image || constant.NOIMAGESNAP;

    const lineItemKey = `lineItem${idx}`;
    const { isProductDeleted } = lineItem;
    const lineItemPrice = isBigCommerceUser ? lineItem.basePrice : lineItem.price;
    const lineTotalPrice = parseFloat(lineItemPrice) * lineItem.quantity;
    const badgeType = baseHelper.getBadgeType(constant.COMPLETE);
    const lineItemName = <div className="productName">{lineItem.name}</div>;
    const productId = baseHelper.mongoIdAsString(lineItem.productId);

    const typeValue = lineItem && lineItem.fulfillmentType;
    const typeData = fulfillmentType;
    if (typeValue && _.isArray(typeData) && !typeData.includes(typeValue)) {
      typeData.push(typeValue);
    }
    setFulfillmentType(typeData);

    return (
      <div key={lineItemKey} className="badge-gap">
        <Card.Section subdued>
          <StyledCard className="styled-card-unfulfill">
            <InlineStack wrap={false}>
              <Thumbnail size="large" source={lineImage} />
              <>
                {(isProductDeleted && (lineItemName || "")) || (
                  <Link onClick={() => navigate(`/product-lake/edit/${productId}`)}>{lineItem.name || ""}</Link>
                )}
                <Text variant="bodySm" as="p">
                  <Text as="span" tone="subdued">
                    {cms("label.skuList")}
                    {lineItem.sku}
                  </Text>
                </Text>
                <InlineStack align="center">
                  <Badge status={badgeType} className="text-capitalize">
                    completed
                  </Badge>
                  <Button variant="plain" onClick={() => window.open(`/orderlake-slip/${id}`)}>
                    <BlockStack gap="2" align="center">
                      <Icon source={NoteIcon} />
                      <Text as="span">{`${cms("label.packingSlip")}`}</Text>
                    </BlockStack>
                  </Button>
                </InlineStack>
              </>
              <Text as="span">{` ${cms("label.qty")}: ${lineItem.quantity}`}</Text>
              {` ${cms("label.price")}: ${moneyFormat}${parseFloat(lineItemPrice || 0).toFixed(2)}`}
              {/* <Text as="span">
                {` ${cms("label.total")}: ${moneyFormat}${parseFloat(lineTotalPrice || 0).toFixed(2)}`}
              </Text> */}
            </InlineStack>
          </StyledCard>
        </Card.Section>
      </div>
    );
  });
  const totalFulfill = (
    <Card.Section>
      <InlineStack align="center">
        <Text as="span" fontWeight="semibold">
          {cms("label.total")}
        </Text>
        <Text variant="bodySm" as="p">{`${countItems} items from ${addVendorTxt}`}</Text>
        <Text as="span" fontWeight="semibold">
          {moneyFormat}
          {totalAmount.toFixed(2)}
        </Text>
      </InlineStack>
    </Card.Section>
  );
  return [lineItems, totalFulfill];
};

FulfilledLineItems.propTypes = fulfilledLineItemsProps.type;

export default FulfilledLineItems;
